import PropTypes from 'prop-types';

export const returnToProvisionPropType = PropTypes.arrayOf(
  PropTypes.shape({
    leid: PropTypes.string.isRequired,
    cdr_number: PropTypes.string.isRequired, // eslint-disable-line camelcase
    reporting_period: PropTypes.string.isRequired, // eslint-disable-line camelcase
    me_code: PropTypes.string, // eslint-disable-line camelcase
    ledger: PropTypes.string,
    curr: PropTypes.string,
    local_chart: PropTypes.string, // eslint-disable-line camelcase
    postingAcct: PropTypes.string,
    tradingPartner: PropTypes.string,
    tp_cdr_number: PropTypes.string, // eslint-disable-line camelcase
    tp_rpt_pd: PropTypes.string, // eslint-disable-line camelcase
    amount: PropTypes.string,
    schdmTemplateId: PropTypes.string,
    schdmTemplateDesc: PropTypes.string,
    schdMType: PropTypes.string,
    schdMSource: PropTypes.string,
    tbbsAcct: PropTypes.string,
    rollFwdNextYear: PropTypes.string,
    schdMProvisonYorN: PropTypes.string,
    project: PropTypes.string,
    projectStep: PropTypes.string,
    baseLineYorN: PropTypes.string,
    comments: PropTypes.string,
    tradingPartnerME: PropTypes.string,
  }));
